import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from "@/core/services/api.service";
//import { VERIFY_AUTH } from "@/store/auth.module";
//import { RESET_LAYOUT_CONFIG } from "@/store/config.module";
import moment from 'moment';
moment.locale('es');

import VueProgressBar from "@aacassandra/vue3-progressbar";
const options = {
  color: '#ffa800',
  failedColor: "#874b4b",
  height: '3px',
  thickness: '4px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  position: 'fixed'
};

/*axios */
import axios from 'axios'
import VueAxios from 'vue-axios'

import 'animate.css';

/*element ui */
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import locale from 'element-plus/lib/locale/lang/es'

import "@/core/plugins/metronic";

import VueApexCharts from "vue3-apexcharts";

// API service init
ApiService.init();

const publicPages = ['/login', '/register', '/credential/:id'];
router.beforeEach((to, from, next) => {
  const authRequired = !publicPages.includes(to.path);
  if (authRequired && !store.getters.isAuthenticated) {
    next({ path: '/login' });
  }
  next();
});

let app=createApp(App);

app.config.globalProperties.$moment=moment;

app.use(router).use(store).use(ElementPlus, { locale }).use(VueAxios, axios).use(VueApexCharts).use(VueProgressBar, options).mount('#app')
